const GetRandomInt = (max: number) => {
    return Math.floor(Math.random() * max);
}
export default GetRandomInt;
